import { Component } from "vue";
import { NotificationType } from "./notification-types";
import MailIcon from "@/ui-library/icons/mail-icon.vue";
import FormIcon from "@/ui-library/icons/form-icon.vue";
import FlaskIcon from "@/ui-library/icons/flask-icon.vue";
import CalendarIcon from "@/ui-library/icons/calendar-icon.vue";
import ChatIcon from "@/ui-library/icons/chat-icon.vue";
import NoteIcon from "@/ui-library/icons/note-icon.vue";
import HeartRateIcon from "@/ui-library/icons/heart-rate-icon.vue";

export function getNotificationIcon(type: NotificationType): Component {
  switch (type) {
    case "Letter":
      return MailIcon;
    case "FilledPdfForm":
      return FormIcon;
    case "Result":
      return FlaskIcon;
    case "Appointment":
      return CalendarIcon;
    case "PatientMessage":
    case "PatientConversation":
      return ChatIcon;
    case "ImportedFile":
    case "MessageFile":
      return NoteIcon;
    case "Careplan":
      return HeartRateIcon;
    default:
      throw new Error(`Unknown notification type: ${type}`);
  }
}

export function getNotificationText(type: NotificationType): string {
  switch (type) {
    case "Letter":
      return "You Have Received a New Letter";
    case "FilledPdfForm":
      return "You Have a New PDF Form";
    case "Result":
      return "You Have Received a New Result";
    case "Appointment":
      return "You Have a New Booked Appointment";
    case "PatientMessage":
    case "PatientConversation":
      return "You Have a New Message";
    case "ImportedFile":
      return "You Have Received a New Other Document";
    case "MessageFile":
      return "You Have Received a New Message File";
    case "Careplan":
      return "You Have Received a New Care Plan";
    default:
      return "You Have a New Notification";
  }
}
